import * as yup from 'yup';

export const schemaCrmTemplate = yup.object().shape({
  name: yup
    .string()
    .required('Nome do template é obrigatório')
    .min(3, 'Nome deve ter pelo menos 3 caracteres')
    .max(150, 'Nome deve ter no máximo 150 caracteres'),
  subject: yup
    .string()
    .max(200, 'Assunto deve ter no máximo 200 caracteres')
    .nullable()
    .notRequired(),
  body_text: yup
    .string()
    .required('Conteúdo do template é obrigatório')
    .min(1, 'Conteúdo do template não pode ser vazio')
    .max(5000, 'Conteúdo do template deve ter no máximo 5000 caracteres'),
  category: yup
    .string()
    .max(100, 'Categoria deve ter no máximo 100 caracteres')
    .nullable()
    .notRequired(),
  description: yup
    .string()
    .max(500, 'Descrição deve ter no máximo 500 caracteres')
    .nullable()
    .notRequired(),
  is_active: yup.boolean().default(true),
});
